import http from '@/biz/http.mjs'
import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import SoftwareMap from '../../../SoftwareMap.jsx'

export const checkCircularReference = () => {
    const openModal = useOpenModal()

    return () => async function () {
        const {bizNodeType, pkid} = this.root.data

        if (! /^(BD|UI)$/.test(bizNodeType)) {
            return
        }

        const {map} = await http.post(
            '/referenceCheck/circularReference',
            {bizNodeType, pkid}
        ) ?? {}

        if (! map) {
            return
        }

        const errMsg = '检测到循环引用'

        await openModal(
            <Alert
                title={errMsg}
                width="90vw"
                height="90vh"
            >
                <SoftwareMap mapData={map} />
            </Alert>
        )

        throw new Error(errMsg)
    }
}
